import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        // 브라우저 뒤로가기 등은 이전 스크롤 복원
        if (savedPosition) return savedPosition
        // 해시 앵커가 있으면 그 위치로
        if (to.hash) return { el: to.hash, top: 0 }
        // 기본은 항상 맨 위
        return { left: 0, top: 0 }
    }
}